var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvanceFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7562 1.30682C5.46406 1.30682 5.22062 1.4042 5.02586 1.59896C4.83111 1.79372 4.73373 2.03716 4.73373 2.3293C4.73373 2.55651 4.80676 2.7675 4.95283 2.96225L8.23935 7.14952V8.70757C8.23935 9.01594 8.36107 9.27561 8.60451 9.4866L10.8686 11.2638C11.1445 11.4423 11.4204 11.4666 11.6963 11.3368C11.9722 11.2069 12.1182 10.9716 12.1345 10.6308V7.14952L15.421 2.96225C15.5671 2.7675 15.6401 2.55651 15.6401 2.3293C15.6401 2.03716 15.5427 1.79372 15.348 1.59896C15.1532 1.4042 14.9098 1.30682 14.6176 1.30682H5.7562ZM9.28616 6.58959L6.07268 2.47536H14.3255L11.0877 6.58959C11.0065 6.7032 10.9659 6.82493 10.9659 6.95476V9.85177L9.40788 8.61019V6.95476C9.40788 6.82493 9.36731 6.7032 9.28616 6.58959ZM4.02773 2.86488H1.08204C0.789907 2.86488 0.546462 2.96225 0.351705 3.15701C0.156949 3.35177 0.0595703 3.59521 0.0595703 3.88735C0.0595703 4.11456 0.132604 4.32555 0.278671 4.52031L3.56519 8.70757V9.4866C3.56519 9.79496 3.68691 10.0546 3.93036 10.2656L6.1944 12.0428C6.47031 12.2213 6.74621 12.2456 7.02212 12.1158C7.29802 11.986 7.44409 11.7506 7.46032 11.4098V8.70757V7.41731L7.21687 7.12518L6.4135 8.14765C6.33235 8.26126 6.29178 8.38298 6.29178 8.51282V10.6308L4.73373 9.38922V8.51282C4.73373 8.38298 4.69315 8.26126 4.612 8.14765L1.39852 4.03342H4.80676L4.34421 3.4248C4.19815 3.2625 4.09265 3.07586 4.02773 2.86488Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 13.26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceFilter);
export default __webpack_public_path__ + "static/media/advance-filter.49ccd2285d4e7f9af0820e22903190d0.svg";
export { ForwardRef as ReactComponent };